import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import type { RecentActivity as RecentActivityItem } from "@/services/api/dashboard";
import { fallbackIcons, getToneStyle, iconMap } from "./dashboardUi";
import { SectionHeader } from "./SectionHeader";
import { StatusPill } from "./StatusPill";

type RecentActivityProps = {
  activities: RecentActivityItem[];
};

export function RecentActivity({ activities }: RecentActivityProps) {
  return (
    <section className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm">
      <SectionHeader title="Recent Activity" />

      <div className="divide-y divide-slate-200">
        {activities.length === 0 && (
          <div className="flex min-h-[180px] items-center justify-center text-sm font-semibold text-slate-500">
            No recent activity yet.
          </div>
        )}

        {activities.map((item) => {
          const Icon = iconMap[item.iconName] || fallbackIcons.phone;
          const tone = getToneStyle(item.colorTone);

          return (
            <article
              key={item.activityId}
              className="grid min-h-[63px] grid-cols-[42px_minmax(0,1fr)_76px_88px] items-center gap-3 py-3 max-sm:grid-cols-[42px_minmax(0,1fr)]"
            >
              <div
                className={`flex h-10 w-10 items-center justify-center rounded-full ${tone.soft} ${tone.text}`}
              >
                <Icon size={21} />
              </div>
              <div className="min-w-0">
                <h3 className="truncate text-sm font-bold text-slate-800">
                  {item.activityTitle}
                </h3>
                <p className="truncate text-xs font-medium text-slate-500">
                  {item.activityDescription}
                </p>
              </div>
              <time className="whitespace-nowrap text-xs font-semibold text-slate-500 max-sm:col-start-2">
                {item.activityTime}
              </time>
              <span className="max-sm:col-start-2 max-sm:justify-self-start">
                <StatusPill status={item.statusLabel} />
              </span>
            </article>
          );
        })}
      </div>

      <Link
        to="/auto-dialer"
        className="mt-2 flex items-center justify-end gap-2 text-sm font-bold text-blue-600"
      >
        View all activity
        <ArrowRight size={18} />
      </Link>
    </section>
  );
}
